/* eslint-disable
    no-unused-vars,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
class SavedSearchService {
   $q: any
   appState: any
   cloudStorage: any
   cloudStoreFn: any
   config: any
   fileId: any
   filename: any
   fire: any
   i18n: any
   savedSearchBucket: any
   scope: any
   store: any
   constructor(config: any, appState: any, cloudStorage: any, i18n: any, $q: any, store: any, hooksService: any) {
      // cloud-related vars
      this.signInHandler = this.signInHandler.bind(this)
      this.signOutHandler = this.signOutHandler.bind(this)
      this.reset = this.reset.bind(this)
      this.resetCurrentSearch = this.resetCurrentSearch.bind(this)
      this.setCurrentSearch = this.setCurrentSearch.bind(this)
      this.saveSearch = this.saveSearch.bind(this)
      this.removeSearch = this.removeSearch.bind(this)
      this.removeAllSearches = this.removeAllSearches.bind(this)
      this.storeList = this.storeList.bind(this)
      this.cloudStoreList = this.cloudStoreList.bind(this)
      this.updateScope = this.updateScope.bind(this)
      this.getSavedSearches = this.getSavedSearches.bind(this)
      this.getFilterText = this.getFilterText.bind(this)
      this.config = config
      this.appState = appState
      this.cloudStorage = cloudStorage
      this.i18n = i18n
      this.$q = $q
      this.store = store
      this.filename = "savedSummonSearches.json"
      this.fileId = null

      // session-related vars
      this.savedSearchBucket = this.store.bucket('savedSearches', true)

      this.scope = {
         savedSearches: this.savedSearchBucket.get('searches') || [],
         retrieving: false
      }

      this.resetCurrentSearch()

      // set up hooks
      hooksService.setHooks(this, 'SavedSearchService', ['getSearches'], true)

      // pull in saved searches when user is signed in
      this.cloudStorage.on('signIn', 'savedSearchService', this.signInHandler)

      // clear saved searches when user signs out
      this.cloudStorage.on('signOut', 'savedSearchService', this.signOutHandler)
   }


   signInHandler() {
      if (this.scope.retrieving) { return }
      this.getSavedSearches()
      // set cloud store function
      return this.cloudStoreFn = this.cloudStoreList
   }

   signOutHandler() {
      this.reset()
      // reset cloud store function
      return this.cloudStoreFn = null
   }

   reset() {
      this.fileId = null
      return this.scope.savedSearches = this.savedSearchBucket.get('searches') || []
   }
   //TODO clear any displayed errors?

   resetCurrentSearch() {
      return this.scope.currentSearch = {
         name: "",
         filterText: "",
         activeIdx: -1,
         saved: false
      }
   }

   // handles setting current search in both modal and in dialog
   setCurrentSearch(searchItem: any, idx=-1) {
      let name, params
      this.resetCurrentSearch()

      // set name and params when handling an edit
      if (searchItem) {
         name = searchItem.name || searchItem.params.q;
         ({
            params
         } = searchItem)
      }

      return this.scope.currentSearch = {
         name: name || this.appState.params.q,
         filterText: this.getFilterText(params || this.appState.params),
         activeIdx: idx,
         saved: false
      }
   }

   // returns a promise
   saveSearch() {
      const newSearchList = angular.copy(this.scope.savedSearches)
      const {
         currentSearch
      } = this.scope

      // save a new item if activeIdx is -1
      if (currentSearch.activeIdx < 0) {
         newSearchList.unshift({
            name: currentSearch.name,
            params: angular.copy(this.appState.params)
         })
      } else { // it's an edit
         newSearchList[currentSearch.activeIdx].name = currentSearch.name
      }

      return this.storeList(newSearchList)
   }

   removeSearch(idx: any) {
      const newSearchList = angular.copy(this.scope.savedSearches)
      const removed = newSearchList.splice(idx, 1)
      return this.storeList(newSearchList, removed[0])
   }

   removeAllSearches() {
      return this.storeList([], true)
   }

   storeList(searchList: any, removedItem=false) {
      // store to cloud if capability exists
      if (this.cloudStoreFn) {
         return this.cloudStoreFn(searchList, removedItem)
      } else {
      // save to session
         this.savedSearchBucket.set('searches', searchList)
         this.updateScope(searchList, removedItem)
         return this.$q((resolve: any, reject: any) => resolve({}))
      }
   }

   cloudStoreList(searchList: any, removedItem=false) {
      return this.cloudStorage.writeToFile(searchList, this.fileId, 'searches', removedItem).then((response: any) => {
      // errors are handled in controller or directive
      // if the cloud service wants to update this with a new list (userService does this to keep track of IDs)
      // we can return this newSavedSearchesList key with an array, otherwise it uses the internal searchList
         if (response.newSavedSearchesList) {
            this.updateScope(response.newSavedSearchesList, removedItem)
         } else {
            this.updateScope(searchList, removedItem)
         }
         return response
      })
   }

   updateScope(searchList: any, removedItem=false) {
      this.scope.savedSearches = searchList
      if (!removedItem) {
         const {
            currentSearch
         } = this.scope
         currentSearch.saved = true
         // reset current search only if editing an existing search
         if (currentSearch.activeIdx >= 0) { return this.resetCurrentSearch() }
      }
   }

   getSavedSearches() {
      this.scope.retrieving = true

      const getFileContents = () => {
         return this.cloudStorage.getFileContents(this.fileId, 'searches')
            .then((response: any) => {
               this.scope.retrieving = false
               const cloudSearches = (_.isEmpty(response) || !Array.isArray(response)) ? [] : response
               const sessionSearches = this.scope.savedSearches.slice()

               // Deduplicate cloud searches and build identity set
               const seen = new Set<string>()
               const getSearchKey = (s: any) => {
                  if (!s) { return '' }
                  const name = s.name || ''
                  const params = (typeof s.params === 'string') ? s.params : JSON.stringify(s.params || {})
                  return name + '||' + params
               }

               const uniqueCloudSearches = cloudSearches.filter((s: any) => {
                  if (!s) { return false }
                  const key = getSearchKey(s)
                  if (seen.has(key)) { return false }
                  seen.add(key)
                  return true
               })

               // Filter session searches that don't already exist in cloud,
               // and deduplicate duplicates already present in session storage
               const uniqueSessionSearches = sessionSearches.filter((s: any) => {
                  if (!s) { return false }
                  const key = getSearchKey(s)
                  if (seen.has(key)) { return false }
                  seen.add(key)
                  return true
               })

               const cloudHadDuplicates = uniqueCloudSearches.length < cloudSearches.length

               if (uniqueSessionSearches.length > 0 || cloudHadDuplicates) {
                  // Session has new searches to add, or cloud had duplicates to clean up
                  this.scope.savedSearches = uniqueSessionSearches.concat(uniqueCloudSearches)
                  return this.cloudStorage.writeToFile(this.scope.savedSearches, this.fileId, 'searches').then((response: any) => {
                     if (response && response.newSavedSearchesList) {
                        this.scope.savedSearches = response.newSavedSearchesList
                     }
                     return this.savedSearchBucket.clear()
                  }).catch(() => {
                     // Write-back failed — keep the deduped list in scope (already set above)
                     // and preserve the local bucket so the user can retry syncing later.
                     // Do not propagate to the outer catch, which would reset everything.
                     return this.scope.savedSearches
                  })
               } else {
                  this.scope.savedSearches = uniqueCloudSearches
                  if (sessionSearches.length > 0) {
                     this.savedSearchBucket.clear()
                  }
                  return this.scope.savedSearches
               }
            }).catch((err: any) => {
               this.reset()
               // in order for registered hooks to process the error, fire 'getSearches' with parsed error
               this.fire('getSearches', err)
               return this.scope.retrieving = false
            })
      }

      if (this.fileId) {
      // get saved searches if we already have file id
         return getFileContents()
      } else {
      // get file id (from list or create file) then get contents
         return this.cloudStorage.getFileId(this.filename).then((fileId: any) => {
            this.fileId = fileId
            return getFileContents()
         }).catch((err: any) => {
            this.reset()
            // in order for registered hooks to process the error, fire 'getSearches' with parsed error
            this.fire('getSearches', err)
            return this.scope.retrieving = false
         })
      }
   }

   getFilterText(params: any) {
      const filters = []
      if (!params.ho) { filters.push(this.i18n.translations.EXPANDED_RESULTS) }
      if ((params.myinst != null) && (params.myinst !== '')) { filters.push(this.i18n.translations.ITEMS_AT_MY_INSTITUTION) }
      if ((params.jt != null) && (params.jt !== '')) { filters.push(this.i18n.translations.JOURNAL_TITLE) }
      if (params.oaf) { filters.push(this.i18n.translations.OPEN_ACCESS_ITEMS_ONLY) }
      if ((params.rf != null) && (params.rf !== '')) { filters.push(this.i18n.translations.PUB_DATE_RANGE) }

      // combine list of all facets and quick filters
      const allFacets = this.config.data.facets.concat(this.config.data.quickFilters.filters)

      // retrieve filter/facet labels from fvf param
      _.each(params.fvf, (facetValue: any) => {
         const facetName = facetValue.split(',')[0]
         const facet = _.find(allFacets, (f: any) => (f.name === facetName) || (f.facet === facetName))
         if (facet != null) { return filters.push(facet.label) }
      })

      if (filters.length) {
         return this.i18n.translations.BY + " " + _.uniq(filters).join(", ")
      } else {
         return ""
      }
   }
}

SavedSearchService.$inject = ['configService', 'appStateService', 'cloudStorageService', 'translationService', '$q', 'storeService', 'hooksService']

angular.module('summonApp.services')
   .service('savedSearchService', SavedSearchService)
